export default {
  title: "",
  subtitle: "Brazilian Companies Registration",
  path: "company_registration_br",
  paragraph: "In Brazil, the document_type for companies is the CNPJ (a 14 digit-number), below you can check a payload sample for registration of a person in Brazil. For other requirements depending on payment methods, check the table in section 'Information needed for registration (Companies)'.",
  request: {
    payload:{ 
  "company": { 
    "document_number": "45215604065562", 
    "document_type": "cnpj", 
    "social_name": "Company Social Name LTDA", 
    "company_name": "Company Fantasy Name",
    "email": "company@email.com",
    "fiscal_country": "Brasil",
    "partners": [ 
      { 
        "document_number": "92331064322",
        "document_type": "CPF/CNPJ/TAXID", 
        "kind": "person", 
        "name": "Manoel Silvares", 
        "percentage_share": "50", 
        "address_country": "BR" 
      } 
    ]
  } 
} ,
    responses: {
      "data": {
        "updated_at": "2025-05-02T22:11:08.714019",
        "status": "approved",
        "social_name": "Company's name",
        "required_clearance_level": 1,
        "references": [],
        "phone_number": null,
        "partners": [],
        "net_value": null,
        "net_monthly_average_income": null,
        "main_activity": null,
        "inserted_at": "2025-05-02T22:11:08.672280",
        "id": "01cf5b70-569f-43f5-80a4-7af303c9c003",
        "fiscal_country": "Brasil",
        "email": null,
        "documents": [],
        "document_type": "nit",
        "document_number": "45215604065562",
        "creation_date": null,
        "company_type": null,
        "company_name": null,
        "clearance_level": 1,
        "address_street": null,
        "address_state": null,
        "address_postal_code": null,
        "address_number": null,
        "address_neighborhood": null,
        "address_country": null,
        "address_complement": null,
        "address_city": null,
        "activity_type": null
      }
    }
  },
  parameterPayload: [
    {
      name: "company",
      type: "object",
      required: true,
      description: "An object containing:",
      is_parent: true
    },{
      name: "company.document_number",
      type: "string",
      required: true,
      description: "Company's Document number",
    },{
      name: "company.document_type",
      type: "string",
      required: true,
      description: "Must be CNPJ",
    },{
      name: "company.social_name",
      type: "string",
      required: true,
      description: "Company's name",
    },{
      name: "company.fiscal_country",
      type: "string",
      required: true,
      description: "Brasil",
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectCompanies/CompaniesRegistrationBR.js